function checkMobile(data) {
  let mobile = data;
  if (!/^1[34578]\d{9}$/.test(mobile)) {
    return false;
  } else {
    return true;
  }
}

function checkIdCard(data) {
  let idCard = data;
  if (
    !/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/.test(
      idCard
    )
  ) {
    return false;
  } else {
    return true;
  }
}

function checkBankCard(data) {
  let bankCard = data;
  if (!/^([1-9]{1})(\d{14}|\d{18})$/.test(bankCard)) {
    return false;
  } else {
    return true;
  }
}

export default {
  checkMobile,
  checkIdCard,
  checkBankCard
};
